import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../../environments/environment";

@Injectable()
export class RegisteredClubService {

    url: any = environment.API_URL;


    constructor(
        private http: HttpClient
    ) {

    }

    uploadImage(data:any){
        return this.http.post(this.url + "user/upload-image",data)
    }

    getClubDetails(id:any){
        return this.http.get(this.url + `admin/view-club/${id}`);
    }


    clubList(data){
        return this.http.post(this.url + 'admin/list-club',data);
    }

    updateClub(data){
        return this.http.post(this.url + 'admin/edit-club',data);
    }
}